<template>
    <div ref="cmain1" class="cmain" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
</template>

<script>
import * as methods from './method.js'

export default {
    name: "template.scope134",
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
        jsondata: {
            type: [Array, String],
            default: () => []
        },
        scopedata: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            timer: null,
            defaultdata: [
                { value1: '1月', value2: '570', value3: '系列一', value4: '%' },
                { value1: '2月', value2: '300', value3: '系列一', },
                { value1: '3月', value2: '120', value3: '系列一', },
                { value1: '4月', value2: '430', value3: '系列一', },
                { value1: '5月', value2: '370', value3: '系列一', },
                { value1: '6月', value2: '370', value3: '系列一', },
                { value1: '1月', value2: '470', value3: '系列二', },
                { value1: '2月', value2: '270', value3: '系列二', },
                { value1: '3月', value2: '570', value3: '系列二', },
                { value1: '4月', value2: '170', value3: '系列二', },
                { value1: '5月', value2: '270', value3: '系列二', },
                { value1: '6月', value2: '370', value3: '系列二', },
                { value1: '1月', value2: '470', value3: '系列三', },
                { value1: '2月', value2: '270', value3: '系列三', },
                { value1: '3月', value2: '570', value3: '系列三', },
                { value1: '4月', value2: '170', value3: '系列三', },
                { value1: '5月', value2: '270', value3: '系列三', },
                { value1: '6月', value2: '370', value3: '系列三', },
                { value1: '1月', value2: '470', value3: '系列四', },
                { value1: '2月', value2: '270', value3: '系列四', },
                { value1: '3月', value2: '570', value3: '系列四', },
                { value1: '4月', value2: '170', value3: '系列四', },
                { value1: '5月', value2: '270', value3: '系列四', },
                { value1: '6月', value2: '370', value3: '系列四', },
            ],
            valueMap: [
                { name: "图表名称", key: "value1" },
                { name: '折线图数值', key: 'value2' },
                { name: '图例', key: 'value3' },
                { name: '单位', key: 'value4' },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            autoTimePaused: false,
            numTotals: [], // 动态存储 numtotal 的数组
            timers: [], // 动态存储定时器的数组
            paddedNumCache: [], // 存储补零后的字符串结果
            validDefaultData: [], // 存储符合位数限制的数据
        };
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata() {
            this.DrawEcharts();
        }
    },
    methods: {
        ...methods,
		DrawEcharts() {
			clearInterval(this.timer);
			this.timer = null;
			var echarts = require("echarts");
			var TmyChart = echarts.init(this.$refs.cmain1);
            let datalist = []
			let legend = [];
			let unit = this.defaultdata[0].value4 || ''
            let colormap = ['#1a87fa', '#1fe4e3', '#2a4de2', '#b1e4fd', '#0cd083', '#d0711a', '#79d02d', '#5952d1']
            let lengedmap = [...new Set(this.defaultdata.map((item) => item.value3))]
            if (lengedmap.length > 6) {
                lengedmap = lengedmap.slice(0, 6)
                this.$message('该柱状图图最多支持六组数据，超出部分已隐藏')
            }
            let xAxis = [...new Set(this.defaultdata.map((item) => item.value1))]
            lengedmap.forEach((item, i) => {
                let itemdata = this.defaultdata.filter(del => del.value3 == item)
                let vlist = []
                let left = 50 - (7.5 * lengedmap.length)
                legend.push(
                    {
                        top: "2%",
                        left: left + 15 * i + '%',
                        itemHeight: 12, //图例的高度  文字左边那个
                        itemWidth: 10,
                        textStyle: { color: "#bdc2cb", width: 55, overflow: 'truncate' },
                        data: [{ name: item, icon: "rect" }],
                    }
                )
                itemdata.forEach(del => {
                    let item = {
                        name: del.value1,
                        value: del.value2
                    }
                    vlist.push(item)
                })
                datalist.push(vlist)
            })
            let series = datalist.map((item, i) => {
                return {
                    name: lengedmap[i],
                    data: item,
                    type: "bar",
                    barGap: '0', //柱子之间间距
                    barWidth: 12,
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: colormap[i] // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: "#0b1f42"// 100% 处的颜色
                            }], false)
                        }
                    },
                }
            })
			var Toption = {
				title: [
					{
						text: unit,
						top: "0",
						left: "0",
						textStyle: {
							color: "#979AA0",
							fontSize: 12,
						},
					},
				],
				tooltip: {
					trigger: "axis",
				},
				grid: {
					left: "5px",
					right: "10px",
					bottom: "0px",
					top: "40px",
					containLabel: true,
				},
				legend: [...legend],
				xAxis: {
					type: "category",
					axisTick: {
						show: false,
					},
					axisPointer: {
						type: "shadow",
					},
					axisLabel: {
						interval: 0,
						width: 50,
						overflow: 'truncate', //文字超出宽度截断，默认为...
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
							fontSize: "14",
							lineHeight: 16,
						},
					},
					axisLine: {
						lineStyle: {
							// X 轴颜色配置
							color: "#4792e9",
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: "dashed",
							color: "rgba(231,241,251,.2)",
						},
					},
					data: xAxis,
				},
				yAxis: {
					type: "value",
					splitNumber: 4,
					axisLabel: {
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
						},
						fontSize: 14,
					},
					axisLine: {
						show: false,
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: "dashed",
							color: "rgba(231,241,251,.2)",
						},
					},
				},
				series: [...series],
			};
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(() => {
				if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000);
		},
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.DrawEcharts();
    }
};
</script>

<style lang="scss" scoped>
.cmain {
	width: 435px;
	height: 240px;
	position: relative;
	overflow: hidden;
	padding: 10px 0;
}
</style>